export default __webpack_public_path__ + "static/pic2-afc6a316c092099370179ce895eb714c.jpeg";